import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/images/filetype-pdf-default-icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-5a4fc068")

_pushScopeId("data-v-5a4fc068")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: " text-black-lp-300 text-16px font-bold" }
const _hoisted_3 = {
  key: 1,
  "data-testid": "commercial-invoice-ftz-cipl-table"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/_createVNode("tbody", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-96" })
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-18" })
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-18" })
    ])
  ])
], -1)
const _hoisted_6 = { class: "gap-y-6" }
const _hoisted_7 = { class: "flex w-full mt-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-40" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-40" }, null, -1)
const _hoisted_10 = { class: "flex w-full mt-5" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-40" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-40" }, null, -1)
const _hoisted_13 = { class: "flex mt-5 w-full" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-40" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-200 rounded h-4 w-40" }, null, -1)
const _hoisted_16 = { class: "flex mt-5 w-full" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-row space-x-3 mt-2"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "PDF document",
  class: "rounded object-cover"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row space-x-3 mt-2" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("div", {
      class: "bg-gray-lp-200 rounded",
      style: {"height":"60px","width":"60px"}
    })
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("div", {
      class: "bg-gray-lp-200 rounded",
      style: {"height":"60px","width":"60px"}
    })
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("div", {
      class: "bg-gray-lp-200 rounded",
      style: {"height":"60px","width":"60px"}
    })
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: 
      _ctx.detailData.sttFtzCipl.length > 0 || !_ctx.isShowInfoDetail
        ? 'space-y-1'
        : 'space-y-6'
    
    }, [
      _createVNode(_component_Title, {
        label: _ctx.$t('bookingShipment.column.crossBorderInformation')
      }, null, 8, ["label"]),
      (_ctx.detailData.sttFtzCipl.length > 0 || !_ctx.isShowInfoDetail)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("bookingShipment.column.titleCIPL")), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.detailData.sttFtzCipl.length > 0 && _ctx.isShowInfoDetail)
        ? (_openBlock(), _createBlock("table", _hoisted_3, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("th", null, _toDisplayString(_ctx.$t("bookingShipment.column.detailitemCIPL")), 1),
                _createVNode("th", null, _toDisplayString(_ctx.$t("bookingShipment.column.quantityCIPL")), 1),
                _createVNode("th", null, _toDisplayString(_ctx.$t("bookingShipment.column.priceCIPL")), 1)
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.sttFtzCipl, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", null, _toDisplayString(item.item_detail || "-"), 1),
                  _createVNode("td", null, _toDisplayString(item.quantity != null ? _ctx.formatQuantity(item.quantity) : "-"), 1),
                  _createVNode("td", null, _toDisplayString(item.item_price != null ? _ctx.formatPrice(item.item_price) : "-"), 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isShowInfoDetail)
        ? (_openBlock(), _createBlock("table", _hoisted_4, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("th", null, _toDisplayString(_ctx.$t("bookingShipment.column.detailitemCIPL")), 1),
                _createVNode("th", null, _toDisplayString(_ctx.$t("bookingShipment.column.quantityCIPL")), 1),
                _createVNode("th", null, _toDisplayString(_ctx.$t("bookingShipment.column.priceCIPL")), 1)
              ])
            ]),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          (_ctx.isShowInfoDetail)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                label: _ctx.$t('bookingShipment.column.ftzEmail'),
                value: _ctx.detailData.sttFtzRecipientEmail,
                class: "w-6/12"
              }, null, 8, ["label", "value"]))
            : (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                label: _ctx.$t('bookingShipment.column.ftzEmail'),
                class: "w-6/12"
              }, {
                default: _withId(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["label"])),
          (_ctx.isShowInfoDetail)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 2,
                label: _ctx.$t('bookingShipment.column.ftzIdNumber'),
                value: _ctx.detailData.sttFtzIdentityNumber,
                class: "w-6/12"
              }, null, 8, ["label", "value"]))
            : (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 3,
                label: _ctx.$t('bookingShipment.column.ftzIdNumber'),
                class: "w-6/12"
              }, {
                default: _withId(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["label"]))
        ]),
        _createVNode("div", _hoisted_10, [
          (_ctx.isShowInfoDetail)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                label: _ctx.$t('bookingShipment.column.taxIdentificationNumber'),
                value: _ctx.detailData.sttTaxNumber,
                class: "w-6/12"
              }, null, 8, ["label", "value"]))
            : (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                label: _ctx.$t('bookingShipment.column.taxIdentificationNumber'),
                class: "w-6/12"
              }, {
                default: _withId(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["label"])),
          (_ctx.isShowInfoDetail)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 2,
                label: _ctx.$t('bookingShipment.column.shipmentStatus'),
                value: _ctx.detailData.sttSenderStatus,
                class: "w-6/12"
              }, null, 8, ["label", "value"]))
            : (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 3,
                label: _ctx.$t('bookingShipment.column.shipmentStatus'),
                class: "w-6/12"
              }, {
                default: _withId(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["label"]))
        ]),
        _createVNode("div", _hoisted_13, [
          (_ctx.accountIsNonForeign && _ctx.isShowInfoDetail)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                label: _ctx.$t('bookingShipment.column.piecePerPack'),
                value: _ctx.detailData.sttPiecePerPack,
                class: "w-6/12"
              }, null, 8, ["label", "value"]))
            : (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                label: _ctx.$t('bookingShipment.column.piecePerPack'),
                class: "w-6/12"
              }, {
                default: _withId(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["label"])),
          (_ctx.accountIsNonForeign && _ctx.isShowInfoDetail)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 2,
                label: _ctx.$t('bookingShipment.column.nextCommodity'),
                value: _ctx.detailData.sttNextCommodity,
                class: "w-6/12"
              }, null, 8, ["label", "value"]))
            : (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 3,
                label: _ctx.$t('bookingShipment.column.nextCommodity'),
                class: "w-6/12"
              }, {
                default: _withId(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["label"]))
        ]),
        _createVNode("div", _hoisted_16, [
          (_ctx.isShowInfoDetail)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                label: _ctx.$t('bookingShipment.column.logisticsDocumentationPhoto'),
                class: "w-6/12"
              }, {
                default: _withId(() => [
                  (_ctx.photos.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_17, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.photos, (photo) => {
                          return (_openBlock(), _createBlock("div", { key: photo }, [
                            (_ctx.isPdfDocument(photo))
                              ? (_openBlock(), _createBlock("button", {
                                  key: 0,
                                  type: "button",
                                  "data-testid": "detail-ftz-pdf-download",
                                  class: "h-28 w-20 py-2 px-0.5 flex flex-col items-center rounded bg-gray-lp-1000 cursor-pointer",
                                  title: _ctx.getPdfDisplayName(photo),
                                  "aria-label": _ctx.getPdfDisplayName(photo),
                                  onClick: ($event: any) => (_ctx.downloadPdf(photo)),
                                  style: {"height":"60px","width":"60px"}
                                }, [
                                  _hoisted_18
                                ], 8, ["title", "aria-label", "onClick"]))
                              : photo
                                ? (_openBlock(), _createBlock("img", {
                                    key: 1,
                                    src: photo,
                                    alt: "photo",
                                    class: "rounded object-cover cursor-pointer",
                                    style: {"height":"60px","width":"60px"},
                                    onClick: () => _ctx.onPreview(photo)
                                  }, null, 8, ["src", "onClick"]))
                                : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]))
            : (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                label: _ctx.$t('bookingShipment.column.logisticsDocumentationPhoto'),
                class: "w-6/12"
              }, {
                default: _withId(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["label"]))
        ])
      ])
    ], 2),
    _createVNode(_component_ImagePreview, {
      modelValue: _ctx.photoPreview,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.photoPreview = $event)),
      data: _ctx.photoPreviews,
      image: _ctx.photo,
      isTerm: false
    }, null, 8, ["modelValue", "data", "image"])
  ], 64))
})